import onClickOutside from 'react-onclickoutside'
import Dropdown from '../components/Dropdown'

export default onClickOutside(Dropdown)
